import isEmpty from 'lodash/isEmpty';
import { getJson } from '~shared/utils/http';
import { buildSpectateUrl } from '~spa/Utils/Spectate';
import { getMarketBetable } from '~shared/utils/market-utils';
import { updateSelection } from '~shared/utils/selections-utils';
import { getSportIdBySlug } from '~shared/utils/sportsbook';

/**
 * Requests Article data
 *
 * @param {String} sport sport slug
 * @param {String} eventId event id
 * @param {String} articleType article type
 * @returns {Object} response json object
 */
export const getArticles = async (sport, eventId, articleType) => {
    let url = `/article-req/getArticles/${articleType}?`;

    if (eventId) {
        url += `event_id=${eventId}`;
    } else if (sport) {
        const sportId = getSportIdBySlug(sport);
        url += `sport=${sportId}`;
    }

    const response = await getJson(buildSpectateUrl(url));

    if (!response.ok) {
        return { error: true };
    }

    return response.json();
};

const getEventData = data => {
    const {
        article_data: articleData,
        selection_pointers: selectionPointers,
    } = data;

    const {
        event_id: eventId,
        market_id: marketId,
        selection_id: selectionId,
    } = selectionPointers;

    const event = articleData.events?.[eventId];
    const selection = event?.markets?.[marketId]?.selections?.[selectionId];

    return {
        event,
        selection,
        eventId,
        marketId,
        selectionId,
    };
};

/**
 * Sets WS handlers
 *
 * @param {Object} wsData The WS data
 * @param {Function} setSpotlight The function to upadate the Spotlight' state
 * @returns {void}
 */
export const wsHandler = ({
    action,
    events: wsEvents,
}, setSpotlight) => {
    if (action === 'event_off' || action === 'inplay_start') {
        setSpotlight(state => {
            const updatedState = { ...state };
            const {
                event,
                selection,
                eventId,
                marketId,
                selectionId,
            } = getEventData(updatedState);

            if (selection) {
                wsEvents.forEach(wsEventId => {
                    if (wsEventId === eventId) {
                        event.markets[marketId].selections[selectionId] = {
                            ...selection,
                            betable: false,
                        };
                    }
                });
            }

            return updatedState;
        });
    } else if (action === 'price_update') {
        setSpotlight(state => {
            const updatedState = { ...state };
            const {
                event,
                selection,
                eventId,
                marketId,
                selectionId,
            } = getEventData(updatedState);

            if (!isEmpty(event) && !isEmpty(selection)) {
                wsEvents.forEach(wsEvent => {
                    const {
                        id: wsEventId,
                        markets: wsMarkets,
                    } = wsEvent;

                    if (wsEventId === eventId) {
                        const wsMarket = wsMarkets.find(({ id }) => id === marketId);
                        if (wsMarket) {
                            const wsSelection = wsMarket.selections?.[selectionId] || {};
                            const isMarketBetable = getMarketBetable(wsMarket);

                            const selectionName = selection.name;
                            const updatedSelection = updateSelection(selection, wsSelection, isMarketBetable);
                            updatedSelection.name = selectionName;

                            event.markets[marketId].selections[selectionId] = updatedSelection;
                        }
                    }
                });
            }

            return updatedState;
        });
    }
};
